<script lang="ts">
  import Link from "svelte-link";
  export let productItem
</script>
<div class="product-details">
    <Link href="/ecommerce/products">
      <h4>{productItem.name}</h4>
    </Link>
    <p>{productItem.note}</p>
    <div class="product-price">
      $ {productItem.price}
      <del>$ {productItem.discountPrice}</del>
    </div>
</div>